import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

const CustomerAddressesList = (props) => {
    return (
        props.address.map((post)=>{
            return (
                <div className="wide-block pt-2 pb-2" key={post.ID}>
                    <div className="sumup pr-1 pl-1">
                        <h5 className="font-weg-400 mb-05">{post.CIRCLE}
                            <span className="badge chip-warning chip-outline ht-17 font-size-10 font-weg-600 text-upper ltsp">{post.LABEL}</span>
                        </h5>
                        <p className="w-80 font-size-13l font-weg-300 mb-05">{post.ADDRESS}</p>
                        {post.MOBILE_NO && <div className="stateline pin">
                            <span className="text-lgrey font-size-12 mb-05 mr-1">{post.MOBILE_NO}</span>
                        </div>}
                        <div className="stateline pt-1">
                            <Link to={`/addressdetails/${post.ID}`} type="button" className="btn btn-xsm square btn-outline-danger newshadowed shadowed mr-1 mb-1 text-upper">Edit</Link>
                            <button onClick={()=>{props.handleDeleteClickModal(post.ID)}} type="button" className="btn btn-xsm square btn-outline-danger newshadowed shadowed mr-1 mb-1 text-upper">Delete</button>
                        </div>
                    </div>
                    <div className="modal fade dialogbox" id={`ModalDeleteAddress_${post.ID}`} data-backdrop="static" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">&nbsp;</h5>
                                </div>
                                <div className="modal-body"> 
                                    You are about to delete this address. Continue? 
                                </div>
                                <div className="modal-footer">
                                    <div className="btn-inline"> 
                                        <button type="button" className="btn btn-text-success" data-dismiss="modal" onClick={()=>{props.handleClickDeleteAddress(post.ID)}}>Yes</button>
                                        <button type="button" className="btn btn-text-danger" data-dismiss="modal">No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    );
}

class CustomerAddresses extends React.Component {
    constructor(props) {
        //console.log(props);
        super(props);
        this.state = {
            LOADING: true,
            LOCATION: this.props.location.pathname,
            CustomerAddresses: [],
            CUSTOMER_DET: ''
        };
    }

    fetchCustomerAddresses(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/customeralladdress_api.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            let customer_address = result.addresses;
            if(customer_address=='' || customer_address==undefined)
                customer_address = '';

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                        
            that.setState({ LOADING:false, CustomerAddresses:customer_address, CUSTOMER_DET:CUSTOMER_DET });
        });
    }

    handleDeleteClickModal = (id) => {
        $('#ModalDeleteAddress_'+id).modal('show');
    }
        
    handleClickDeleteAddress = (id) => {
        $('#submitLoading_'+id).css('display','block');
            
        let customer = '';

        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        let mode = 'DELETE_ADDRESS';
        var that = this;
        fetch('https://m.donedelivery.in/api/customeraddaddress_api.php?mode='+mode+'&customer='+customer+'&address_id='+id,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {

            //console.log(result);
            let deleted = result.deleted;
            if(deleted=='' || deleted==undefined)
                deleted = '';

            if(deleted=='Y')
            {
                let address_id = localStorage.getItem('addressID');
                if(address_id==id)
                {
                    localStorage.removeItem('addressID');
                }
            }

            that.fetchCustomerAddresses('ADDRESS',customer);
            if(deleted=='Y')
                $('#ModalAlert2').modal('show');
        });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        this.fetchCustomerAddresses('ADDRESS',customer);
    }

    render() { 

        let logged = 'N';
        if(localStorage.getItem('userData'))
            logged = 'Y';

        if (logged=='N')
        {
            if(localStorage.getItem('cartData'))
                return (<Redirect to={'/cart'}/>)
            else
                return (<Redirect to={'/home'}/>)
        }
        
        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/profile';
        let AppHeaderTitle = 'Adresses';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        let props = {
            address: this.state.CustomerAddresses,
            handleClickDeleteAddress: this.handleClickDeleteAddress,
            handleDeleteClickModal: this.handleDeleteClickModal
        };

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="delivery-location section full mt-0">
                        { this.state.CustomerAddresses.length!='' && <CustomerAddressesList {...props} /> }
                        { this.state.CustomerAddresses.length=='' && 
                            <div className="section pt-6" style={{textAlign: 'center'}}>
                                <img src="/assets/img/no-address.png" alt="no-address" className="form-image imaged w200" />
                            </div>}
                    </div>
                    <div className="form-button-group1 pr-2 pl-2">
                        <div className="col-12">
                            <div className="text-upper">
                                <div className="row">
                                    <div className="col-12">
                                        <Link to="/addaddress2" className="btn newshadowed font-size-14 square btn-danger btn-ssm btn-block">Add New Address</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade dialogbox" id="ModalAlert2" data-backdrop="static" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-icon text-success">
                                    <ion-icon name="checkmark-circle"></ion-icon>
                                </div>
                                <div className="modal-body"> 
                                    Address Details Deleted Successfully 
                                </div>
                                <div className="modal-footer">
                                    <div className="btn-inline"> 
                                        <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
  
export default CustomerAddresses;


// WEBPACK FOOTER //
// ./src/components/CustomerAddresses.js